// Avatar background colors — cycled by name charcode
export const AVATAR_COLORS = [
  { bg: "rgba(40,179,180,0.18)",  border: "rgba(40,179,180,0.4)",  text: "#28B3B4" },
  { bg: "rgba(214,223,39,0.18)",  border: "rgba(214,223,39,0.4)",  text: "#8A9200" },
  { bg: "rgba(74,153,96,0.18)",   border: "rgba(74,153,96,0.4)",   text: "#4a9960" },
  { bg: "rgba(122,90,189,0.18)",  border: "rgba(122,90,189,0.4)",  text: "#7a5abd" },
  { bg: "rgba(212,128,58,0.18)",  border: "rgba(212,128,58,0.4)",  text: "#D4803A" },
  { bg: "rgba(58,184,212,0.18)",  border: "rgba(58,184,212,0.4)",  text: "#3ab8d4" },
];

// Derive avatar color from name string
export const getAvatarColor = (name = "") => {
  const code = (name.charCodeAt(0) || 0) + (name.charCodeAt(1) || 0);
  return AVATAR_COLORS[code % AVATAR_COLORS.length];
};

// Derive initials from full name
export const getInitials = (name = "") => {
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Filter tab definitions
export const FILTER_TABS = [
  { id: "all",             label: "Total"             },
  { id: "billable",        label: "Billable"        },
  { id: "fully-allocated", label: "Fully Allocated" },
  { id: "partial",         label: "Partial"         },
  { id: "new",             label: "New"             },
  { id: "available",       label: "Available"       },
  { id: "non-billable",    label: "Non-Billable"    },
];